module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "guide"
  }, [_c('h3', [_vm._v("请您完善用户信息，以便于360分析平台和您之间的沟通。")]), _c('p', [_c('router-link', {
    attrs: {
      "to": "/nopermission"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("去完善")])])], 1)]), _c('site-footer')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b3583b02", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b3583b02!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/infoGuide.vue
// module id = 792
// module chunks = 0